import { render } from "./BiometryPrefs.vue?vue&type=template&id=93ab5f20&scoped=true&ts=true"
import script from "./BiometryPrefs.vue?vue&type=script&lang=ts"
export * from "./BiometryPrefs.vue?vue&type=script&lang=ts"

import "./BiometryPrefs.vue?vue&type=style&index=0&id=93ab5f20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ab5f20"]])

export default __exports__